import { UserInput } from 'admin/inputs/UserInput';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import {
  CheckboxGroupInput,
  Create,
  FormDataConsumer,
  getRecordFromLocation,
  RadioButtonGroupInput,
  SimpleForm,
} from 'react-admin';
import { useLocation } from 'react-router-dom';

import { SERVICE_AREA_TYPES, USER_RELATION_TYPES } from './userRelationUtils';

export const UserRelationCreate: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });
  const location = useLocation();
  const record = getRecordFromLocation(location);

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  let allowedRelationTypes: string[] = [];
  if (hasAnyRole([Role.RoleAdmin])) {
    allowedRelationTypes = ['SCOUT', 'MAIN_FINANCIAL_ADVISOR', 'ADDITIONAL_FINANCIAL_ADVISOR'];
  } else if (hasAnyRole([Role.RoleFinancialAdvisor])) {
    allowedRelationTypes = ['ADDITIONAL_FINANCIAL_ADVISOR'];
  }

  const filteredRelationTypes = USER_RELATION_TYPES.filter((relationType) =>
    allowedRelationTypes.includes(relationType.id),
  );
  const defaultRelationType = filteredRelationTypes.length == 1 ? filteredRelationTypes[0].id : null;

  return (
    <Create>
      <SimpleForm>
        <UserInput label="Kto" roles={[Role.RoleFinancialAdvisor, Role.RoleScout]} source="subjectUserId" />
        <RadioButtonGroupInput
          choices={filteredRelationTypes}
          defaultValue={defaultRelationType}
          label="Má vzťah"
          source="relationType"
        />
        <UserInput disabled={!!record?.objectUserId} label="Ku komu" roles={[Role.RoleClient]} source="objectUserId" />
        <FormDataConsumer>
          {({ formData }) =>
            formData.relationType == 'ADDITIONAL_FINANCIAL_ADVISOR' && (
              <CheckboxGroupInput
                choices={SERVICE_AREA_TYPES}
                fullWidth={false}
                label="V oblastiach"
                source="serviceAreas"
                value={'ADDITIONAL_FINANCIAL_ADVISOR'}
              />
            )
          }
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  );
};
